import axios from "axios";
import ServiceException from "@/models/ServiceException";

const baseURL = `${process.env.VUE_APP_API_URL}/api/categories`;

export default {
  async getCategories() {
    const response = await axios.get(`${baseURL}/dataprovider/2`);
    if (response?.data?.responseCode !== 200) {
      throw new ServiceException(response?.data);
    }
    return response.data.result;
  },
};
